import React from "react";
import styled, { css } from "styled-components";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import IndeterminateCheckBoxIcon from "@material-ui/icons/IndeterminateCheckBox";
import { Button as ButtonPrimitive } from "@sonder/ui/source/styled/primitives/Button";
import { colors } from "@sonder/ui/source/styled/theme";

// Styles
export const checkedStyles = css`
  color: ${colors.blue7};

  &:active:not(:disabled) {
    color: ${colors.blue2};
  }
`;
export const uncheckedStyles = css`
  color: ${colors.gray6};

  &:hover:not(:disabled) {
    color: ${colors.gray1};
  }
  &:active:not(:disabled) {
    color: ${colors.blue7};
  }
`;

export const checkboxStyles = css`
  align-items: center;
  display: inline-flex;
  flex: 0 0 1.8rem;
  height: 1.8rem;
  justify-content: center;
  position: relative;

  svg {
    height: 100%;
    pointer-events: none;
    width: 100%;
  }

  &:disabled {
    opacity: 0.5;
  }
`;

// Exports
interface StyledCheckboxProps {
  checked?: boolean;
  indeterminate?: boolean;
}
export const StyledCheckbox = styled(ButtonPrimitive)<StyledCheckboxProps>`
  ${checkboxStyles}
  ${props =>
    props.checked || props.indeterminate ? checkedStyles : uncheckedStyles}
`;

interface CheckboxProps extends React.InputHTMLAttributes<HTMLButtonElement> {
  indeterminate?: boolean;
}
export const Checkbox = ({ ...props }: CheckboxProps) => {
  const { checked, indeterminate } = props;
  return (
    <StyledCheckbox {...props} type="button">
      {checked && !indeterminate && <CheckBoxIcon />}
      {indeterminate && <IndeterminateCheckBoxIcon />}
      {!checked && !indeterminate && <CheckBoxOutlineBlankIcon />}
    </StyledCheckbox>
  );
};
